import React from 'react';
import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';


import Drawer from '@mui/material/Drawer';

import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Slide from '@mui/material/Slide';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export default function MenuPrincipal() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <Box sx={{ flexGrow: 1}}>
      <HideOnScroll>
        <AppBar sx={{paddingTop:'0.5em', paddingBottom:'0.5em'}}>
          <Toolbar>
            <IconButton edge="start" sx={{ mr: 2 }} color="inherit" aria-label="menu" onClick={() => setIsDrawerOpen(true)}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h5" sx={{ flexGrow: 1 }}>
              Marjolaine Benmoussa Graphothérapeute
            </Typography>

            <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
              <List>
                <ListItem button>
                  <ListItemText primary="Graphothérapeute certifiée" onClick={() => {
                    setIsDrawerOpen(false);
                    document.getElementById('Marjolaine').scrollIntoView({behavior: 'smooth'})
                  }}/>
                </ListItem>

                <ListItem button>
                  <ListItemText primary="La dysgraphie" onClick={() => {
                    setIsDrawerOpen(false);
                    document.getElementById('Dysgraphie').scrollIntoView({behavior: 'smooth'})
                  }}/>
                </ListItem>

                <ListItem button>
                  <ListItemText primary="Quand Consulter?" onClick={() => {
                    setIsDrawerOpen(false);
                    document.getElementById('Consulter').scrollIntoView({behavior: 'smooth'})
                  }}/>
                </ListItem>

                <ListItem button>
                  <ListItemText primary="Parcours thérapeutique" onClick={() => {
                    setIsDrawerOpen(false);
                    document.getElementById('Parcours').scrollIntoView({behavior: 'smooth'})
                  }}/>
                </ListItem>

                <ListItem button>
                  <ListItemText primary="Me contacter" onClick={() => {
                    setIsDrawerOpen(false);
                    document.getElementById('Coordonnées').scrollIntoView({behavior: 'smooth'})
                  }}/>
                </ListItem>
              </List>

            </Drawer>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
    </Box>
  );
}